module.exports = __webpack_public_path__ + "img/caslon-icg-open-face.png";